// Common reusable StyleSheet fragments shared across community components.

export const card = {
  backgroundColor: 'rgba(255,255,255,0.04)',
  borderRadius: 12,
  borderWidth: 1,
  borderColor: 'rgba(255,255,255,0.08)',
};

export const row = {
  flexDirection: 'row',
  alignItems: 'center',
};

export const rowBetween = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const clipContent = {
  overflow: 'hidden',
};

export const input = {
  backgroundColor: 'rgba(255,255,255,0.07)',
  borderRadius: 8,
  borderWidth: 1,
  borderColor: 'rgba(255,255,255,0.1)',
  paddingHorizontal: 12,
  paddingVertical: 9,
  color: 'rgba(255,255,255,0.9)',
  fontSize: 14,
};
